// Get Customer Messages
export const GET_CUSTOMER_COMMUNICATION_REQUEST =
  'GET_CUSTOMER_COMMUNICATION_REQUEST';
export const GET_CUSTOMER_COMMUNICATION_SUCCESS =
  'GET_CUSTOMER_COMMUNICATION_SUCCESS';
export const GET_CUSTOMER_COMMUNICATION_FAIL =
  'GET_CUSTOMER_COMMUNICATION_FAIL';

// Send Message To Customer
export const SEND_SMS_OR_EMAIL_TO_CUSTOMER_REQUEST =
  'SEND_SMS_OR_EMAIL_TO_CUSTOMER_REQUEST';
export const SEND_SMS_OR_EMAIL_TO_CUSTOMER_SUCCESS =
  'SEND_SMS_OR_EMAIL_TO_CUSTOMER_SUCCESS';
export const SEND_SMS_OR_EMAIL_TO_CUSTOMER_FAIL =
  'SEND_SMS_OR_EMAIL_TO_CUSTOMER_FAIL';

// Send Message States
export const CLEAR_CUSTOMER_COMMUNICATION_STATES =
  'CLEAR_CUSTOMER_COMMUNICATION_STATES';
